module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"out_of":"out of","report_months_present":"report-months present","details":"details"},"cs":{"out_of":"z celkového počtu","report_months_present":"report-měsíců přítomno","details":"podrobnosti"}}')
  delete Component.options._Ctor
}
